import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SaveActionsBar = ({ 
  hasChanges, 
  isSaving, 
  saveSuccess,
  onSave, 
  onReset 
}) => {
  if (!hasChanges && !saveSuccess) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 lg:left-60 z-50 p-4 bg-secondary/95 backdrop-blur-lg border-t border-accent-cyan/20">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-warning/20 glow-subtle">
            <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">Unsaved Changes</p>
            <p className="text-xs text-muted-foreground">
              You have modified your settings
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 w-full sm:w-auto">
          <Button
            variant="ghost"
            onClick={onReset}
            disabled={isSaving}
            className="flex-1 sm:flex-none"
          >
            Discard
          </Button>
          <Button
            variant="default"
            iconName="Save"
            iconPosition="left"
            loading={isSaving}
            onClick={onSave}
            className="flex-1 sm:flex-none"
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </div>

      {saveSuccess && (
        <div className="mt-3 p-3 rounded-lg bg-success/10 border border-success/20 flex items-center justify-center gap-2">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span className="text-sm text-success">Settings saved successfully</span>
        </div>
      )}
    </div>
  );
};

export default SaveActionsBar;